export type RsvpCloseOption = 'none' | '1h' | '24h'

const HOUR_MS = 3_600_000
const DAY_MS = 86_400_000
const TOLERANCE_MS = 60_000 // 1 minute — absorbs rounding when deriving the bucket back

/** Forward: turn the picker choice into an absolute ISO timestamp (or null = don't close early). */
export function computeRsvpClosesAt(close: RsvpCloseOption, startsAt: string): string | null {
  if (close === 'none' || !startsAt) return null
  const start = new Date(startsAt).getTime()
  if (isNaN(start)) return null
  if (close === '1h') return new Date(start - HOUR_MS).toISOString()
  if (close === '24h') return new Date(start - DAY_MS).toISOString()
  return null
}

/** Inverse: derive the picker choice from a stored close timestamp relative to the start. */
export function deriveRsvpClose(rsvpClosesAt: string | null, startsAt: string): RsvpCloseOption {
  if (!rsvpClosesAt || !startsAt) return 'none'
  const start = new Date(startsAt).getTime()
  const closes = new Date(rsvpClosesAt).getTime()
  if (isNaN(start) || isNaN(closes)) return 'none'
  const lead = start - closes
  if (Math.abs(lead - HOUR_MS) <= TOLERANCE_MS) return '1h'
  if (Math.abs(lead - DAY_MS) <= TOLERANCE_MS) return '24h'
  return 'none'
}
